import React, { useRef, useState } from "react";
import ChatArea from "components/ai_tools/ChatArea";

const demoContainerStyles = {
  height: "828px",
  width: "850px"
};

const demoFormStyles = {
  display: "flex",
  gap: "2px"
};

export default function ChatAreaDemo() {
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [streamState, setStreamState] = useState("default");
  const inputRef = useRef();

  const handleClick = (variant) => {
    if (currentMessage === "") {
      return;
    }

    const newMessage = {
      children: currentMessage,
      slideUp: true,
      streamState: variant === "user" ? "default" : streamState,
      variant
    };
    const newMessages = [...messages, newMessage];

    setMessages(newMessages);
    setCurrentMessage("");
    setStreamState("default");
    inputRef.current.focus();
  };

  const handleInputChange = (event) => {
    setCurrentMessage(event.target.value);
  };

  const handleDropdownChange = (event) => {
    setStreamState(event.target.value);
  };

  return (
    <div style={demoContainerStyles}>
      <div style={demoFormStyles}>
        <input
          ref={inputRef}
          type="text"
          onChange={handleInputChange}
          value={currentMessage}
        />
        <select onChange={handleDropdownChange} value={streamState}>
          <option value="default">Default</option>
          <option value="loading">Loading</option>
          <option value="streaming">Streaming</option>
        </select>
        <button type="button" onClick={() => handleClick("server")}>
          Server
        </button>
        <button type="button" onClick={() => handleClick("user")}>
          User
        </button>
      </div>
      <ChatArea messages={messages} />
    </div>
  );
}
